import axios from 'axios';

export const locationApi = axios.create({
  baseURL: 'https://ipapi.co/',
});
